import React from 'react'

import useSwr from 'swr'
import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const fetcher = () =>
  TablaComunService.getAsSelect(TiposTablaComunConstant.SUNAT_TIPO_ACTIVO_FIJO).then(({ data }) => data)

const TipoActivoFijoSunatFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const { data: tipos } = useSwr('select_sunat_tipo_activo_fijo', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false
  })

  return (
    <Form.Group>
      <Form.Label text='TIPO SUNAT' htmlFor='select-tipoActivoFijoSunat' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoActivoFijoSunat'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-tipoActivoFijoSunat'>
              <option value=''>Seleccionar</option>
              {tipos.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoActivoFijoSunatFormGroup)
